export enum FractionOperatorEnum {
  Or = 'Or',
  And = 'And'
}
